import React from 'react';
import {
  classNames,
  containerClassNames,
  ContainerClassNameProps,
  flowClassNames,
  FlowClassNameProps,
  layoutClassNames,
  LayoutClassNameProps,
  positionClassNames,
  PositionClassNameProps,
  surfaceClassNames,
  SurfaceClassNameProps,
} from './classNames';

export interface BoxProps
  extends React.HTMLAttributes<HTMLElement>,
    ContainerClassNameProps,
    FlowClassNameProps,
    LayoutClassNameProps,
    SurfaceClassNameProps,
    PositionClassNameProps {
  as?: React.ElementType;
  fullHeight?: boolean;
  fullWidth?: boolean;
}

const Box = React.forwardRef<HTMLElement, BoxProps>(({
  as: Component = 'div',
  fullHeight = false,
  fullWidth = false,
  className,
  children,
  container,
  display,
  flexGrow,
  margin,
  marginTop,
  marginEnd,
  marginBottom,
  marginStart,
  marginX,
  marginY,
  padding,
  paddingTop,
  paddingEnd,
  paddingBottom,
  paddingStart,
  paddingX,
  paddingY,
  textAlign,
  background,
  bordered,
  borderless,
  borderColor,
  rounded,
  shadow,
  bottom,
  end,
  fixed,
  position,
  positionTranslate,
  start,
  top,
  overflowY,
  ...props
}, ref) => (
  <Component
    ref={ref}
    className={classNames(
      fullHeight ? 'h-100' : undefined,
      fullWidth ? 'w-100' : undefined,
      containerClassNames({ container }),
      flowClassNames({
        display,
        flexGrow,
        overflowY,
      }),
      positionClassNames({
        bottom,
        end,
        fixed,
        position,
        positionTranslate,
        start,
        top,
      }),
      surfaceClassNames({
        background,
        bordered,
        borderless,
        borderColor,
        rounded,
        shadow,
      }),
      layoutClassNames({
        margin,
        marginTop,
        marginEnd,
        marginBottom,
        marginStart,
        marginX,
        marginY,
        padding,
        paddingTop,
        paddingEnd,
        paddingBottom,
        paddingStart,
        paddingX,
        paddingY,
        textAlign,
      }),
      className,
    )}
    {...props}
  >
    {children}
  </Component>
));

Box.displayName = 'Box';

export default Box;
